import type { BillRateUnit } from '@/lib/types';

/** Display suffix for a bill-rate unit, e.g. "$180/hr" or "$500/day". */
export function billRateUnitSuffix(unit: BillRateUnit | null | undefined): string {
  return unit === 'daily' ? '/day' : '/hr';
}
